export default class CropDownload {
    constructor(box21_api) {
        this.api = box21_api;
    }

    async create(filters) {
        const formData = new FormData();
        formData.append('filters', JSON.stringify(filters || []));
        formData.append('project_id', sessionStorage.getItem('project_id'));
        return this.api.post_with_token('/crop-downloads', formData);
    }

    async list() {
        const formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        return this.api.post_with_token('/crop-downloads/list', formData);
    }

    async delete(downloadId) {
        const formData = new FormData();
        formData.append('project_id', sessionStorage.getItem('project_id'));
        formData.append('download_id', String(downloadId));
        return this.api.post_with_token('/crop-downloads/delete', formData);
    }

    fileUrl(downloadId) {
        const projectId = sessionStorage.getItem('project_id');
        const token = localStorage.token || '';
        const base = this.api.api_url || '';
        return `${base}/crop-downloads/file?download_id=${encodeURIComponent(downloadId)}&project_id=${encodeURIComponent(projectId)}&token=${encodeURIComponent(token)}`;
    }
}
